<template>
  <div class="challenge-container">
    <!-- 标题和介绍部分 -->
    <div class="challenge-header outbox">
			<div class="title">{{ challengeData.tasp_title }} 
        {{ formatTime(challengeData.tasp_start_time*1000,'YYYY.MM.DD') }}-{{ formatTime(challengeData.tasp_end_time*1000,'YYYY.MM.DD') }}</div>
			<div class="info-line">
				<span class="username" v-if="challengeData.update_by">{{ challengeData.update_by }}</span>
				<span class="view-count">
					<i class="el-icon-view"></i>
					{{ challengeData.tasp_hits }} 
				</span>
				<span class="publish-time">发表于 {{ challengeData.update_time }}</span>
			</div>
			<div class="introduction">
				{{ challengeData.tasp_describe }}
			</div>
		</div>

    <!-- 视频课程部分 -->
    <div class="outbox">
      <div class="section-title m16">赋能课程</div>
      <div v-html="challengeData.tasp_content"></div>
      <!-- <VideoPlayer 
        :cover-image="'@/assets/images/play.png'"
        :video-url="'https://www.w3schools.com/html/mov_bbb.mp4'"
        :video-title="'存储智数知识赋能'"
        :video-date="'2025-04-20'"
        :video-duration="'30分钟'"
        :rules="[
          '需要观看完赋能课程后，完成以下题目，即可获得相应积分。',
          '每周1期，每期3道题，全部答对获得3分，答对1题获1分，以此类推。'
        ]"
        @play-state-changed="handlePlayStateChanged"
      /> -->
    </div>

    <!-- 题目和答题区域 -->
    <div class="challenge-content outbox" v-if="!complete">
      <div class="challenge-questions">
        <div class="section-title">赋能题目</div>
        <template v-for="(question, qIndex) in questions" 
          @key="question.taspq_id">
          <QuestionItem 
            :question="question"
            :index="qIndex"
            :taspq_id="question.taspq_id"
            :taspq_type="question.taspq_type"
            :value="userAnswers[qIndex]"
            @select="handleOptionClick"
            @multiSelect="toggleMultiOption"
            @update:text="updateTextAnswer"
            @update:score="updateScoreAnswer"
          />
        </template>
        
      </div>
      
      <div class="action-bar">
        <el-button type="text" class="submit-btn" @click="submitAnswers">提交答案</el-button>
      </div>
    </div>
    
    <!-- 结果页面 -->
    <Result typeNum="2" :ta_id="ta_id" :tas_id="tas_id" :tasp_id="tasp_id" v-if="complete"></Result>
  </div>
</template>

<script>
import Result from './components/result.vue';
import QuestionItem from './components/QuestionItem.vue';
import VideoPlayer from './components/VideoPlayer.vue';
import { taskDetailList,taskSubmit } from '@/api/challenge';

export default {
  name: 'WeeklyChallenge',
  components: {
    Result,
    QuestionItem,
    VideoPlayer
  },
  data() {
    return {
      complete: false,
      isplay: false,
      challengeData: {
        tasp_title: '存储智数大讲堂知识问答 第一周 2025.4.20-2025.4.28',
        update_by: '00246870',
        tasp_hits: 265,
        publishTime: '2 周前',
        tasp_describe: '大家好，我是来自产品经营管理部的张平，很荣幸能有这个分享的机会。我是2019年7月毕业后加入华为的，且入职即在一言在产品经营管理部负责产业经营方向的PPA工作。由于产品经营管理部的定位既要产品财经OCEO担忧，我用两个关键词总结为分别是"连接"与"归因"，要如何连分别是"连接"与"归因"。',
      },
      questions: [],
      userAnswers: [{}],
      videoWatched: false,
    };
  },
  computed: {
    ta_id() {
      return this.$route.params.ta_id; // 获取路由参数 活动id
    },
    tas_id() {
      return this.$route.params.tas_id; // 获取路由参数 阶段id
    },
    tasp_id() {
      return this.$route.params.tasp_id; // 获取路由参数 试卷id
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    handlePlayStateChanged(isPlaying) {
      this.isplay = isPlaying;
      if (!this.videoWatched && isPlaying) {
        // 可以在这里记录用户开始观看视频
        console.log('用户开始观看视频');
      }
    },
    // 初始化获取数据
    async getData() {
      const res = await taskDetailList({
        ta_id: this.ta_id,//358
        tas_id: this.tas_id,//1
        tasp_id: this.tasp_id //15
      });
      if (res.status == 200) {
        if(res.data.status == false){
          this.$message.error(res.data.msg);
          return;
        }
        this.challengeData = res.data.paper;
        if(res.data.paper.is_submit == 10){
          this.complete = true;
          return;
        }
        this.questions = res.data.question.map(item=>{
          if(item.taspq_type == 30){
            item.taspq_options = item.taspq_options.map(option=>{
              return {
                ...option,
                score_min: parseInt(option.score_min),
                score_max: parseInt(option.score_max),
              }
            });
          }
          return item;
        });
        this.initUserAnswers();
      }
    },
		initUserAnswers() {
      this.userAnswers = this.questions.map(item => {
        let obj;
        if(item.taspq_type==10) return {
          taspq_id:item.taspq_id,
          option_title:'',
          value: ''
        };
        if(item.taspq_type == 20) return [];
        if(item.taspq_type == 30) return item.taspq_options.map(option=>{
          return {
            taspq_id:item.taspq_id,
            title:0,
            value:0
          }
        });  
        if(item.taspq_type == 40) return {
          taspq_id:item.taspq_id,
          title:'',
          value:''
        };
      });
    },
    //单选题选择
		handleOptionClick(qIndex, oIndex, option){
      let value = this.userAnswers[qIndex];
      value.option_title = option.title;
      value.value = oIndex;
			this.$set(this.userAnswers, qIndex, value);
		},
			// 多选题选择
		toggleMultiOption(qIndex, oIndex, option,taspq_id) {
      let value = this.userAnswers[qIndex];

      //判断value数组内的value字段是否和oIndex相同
      let isExist = value.some(item => item.value == oIndex);
      if(!isExist){
        value.push({
          taspq_id:taspq_id,
          option_title:option.title,
          value:oIndex
        });
      }else{
        value.splice(value.indexOf(oIndex), 1);
      }
      this.$set(this.userAnswers, qIndex, value);
		},
    // 文本题更新
    updateTextAnswer(index, text) {
      let value = this.userAnswers[index];
      value.title = value.value = text;
      this.$set(this.userAnswers, index, value);
    },
    // 评分题选择
    updateScoreAnswer(index, oIndex, score) {
      let value = this.userAnswers[index];
      value[oIndex].title = value[oIndex].value = score;
      this.$set(this.userAnswers, index, value);
    },
    async submitAnswers() {
      let subObj = {
        ta_id: this.challengeData.ta_id,
        tas_id: this.challengeData.tas_id,
        tasp_id: this.challengeData.tasp_id,
        dd_question_type: this.challengeData.dd_question_type,
        data: this.userAnswers
      }
      // 打印subObj格式化
      // console.log(JSON.stringify(subObj,null,2));

      // 验证是否所有必填题目都已作答
      const requiredQuestions = this.questions.filter(q => q.taspq_require);
      // 判断userAnswers数组中是否存在option_title字段,数组内还有数组的则再遍历一遍
      let isAllAnswer = true;
      this.userAnswers.forEach(item=>{
        if(Array.isArray(item)){
          item.forEach(item2=>{
            if(!item2.title && !item2.option_title){
              isAllAnswer = false;
            }
          });
        }else{
          if((!item.title && !item.option_title) && item.taspq_require){
            isAllAnswer = false;
          }
        }
      });
      
      if (!isAllAnswer) {
        this.$message.error('请回答所有必填题目');
        return;
      }
      
      const res = await taskSubmit(subObj);
      if(res.status == 200){
        this.$message.success('答案提交成功！');
        setTimeout(()=>{
          this.complete = true;
          this.initUserAnswers();
        },2000);
      }else{
        this.$message.error('提交失败，请重试');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.outbox{
  min-width: 1200px;
  max-width: 1680px;
  margin: 0 auto 16px;
  background: #fff;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  box-sizing: border-box;
  padding: 32px;
  &:last-child{
    margin-bottom: 0;
  }
}

.challenge-container {
  width: 100%;
  padding: 80px 120px 20px;
  background: #f9f9f9;
  min-height: 100vh;
  color: #191919;
  
  .challenge-header {
    .title {
      font-size: 26px;
      line-height: 30px;
      margin-bottom: 16px;
    }
    
    .info-line {
      display: flex;
      align-items: center;
      font-size: 14px;
      margin-bottom: 15px;
      height: 22px;
      line-height: 22px;
      
      .username {
        margin-right: 20px;
      }
      
      .view-count {
        display: flex;
        align-items: center;
        margin-right: 20px;
        
        i {
          margin-right: 3px;
        }
      }
      
      .publish-time {
        color: #777777;
      }
    }
    
    .introduction {
      font-size: 14px;
      line-height: 24px;
      font-weight: 300;
      color: #595959;
    }
  }
  
  .section-title {
    font-size: 24px;
    line-height: 30px;
    margin-bottom: 24px;
    
    &.m16{
      margin-bottom: 16px;
    }
  }
  
  .action-bar {
    text-align: center;
    padding: 24px 0 32px;
    margin: 32px 0 0;
    border-top: 1px dashed rgb(230, 230, 230);
    
    .submit-btn {
      box-sizing: border-box;
      font-size: 14px;
      border: 1px solid rgb(179, 0, 0);
      border-radius: 20px;
      width: 86px;
      background: rgb(255, 255, 255);
      color: #B30000;
      cursor: pointer;
      transition: all 0.3s;
      
      &:hover {
        background-color: rgba(179, 0, 0, 0.1);
      }
    }
  }
}
</style>